import fb from '../firebase'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers'
import Data4 from '../data/Data4'
import Vue from 'vue'
import Utilities from '../helpers/Utilities'

var db = fb.database()

const state = {
    collections: {}
}

// getters
const getters = {

    collections: state => {
        return state.collections
    },

    getCollectionData: (state) => (teamName, collectionName) => {
        return  Utilities.objectDeepGet(state.collections, [teamName, collectionName, 'data']) || []     
    },

    getCollection: (state) => (teamName, collectionName) => {
        return  Utilities.objectDeepGet(state.collections, [teamName, collectionName]) || []     
    }

}

// mutations
const mutations = {

    setCollection (state, payload) {

        let collectionPath = `collections/${payload.team}/${payload.collection}`

        Utilities.objectDeepSet(state, `${collectionPath}/data`, payload.data)   
        Utilities.objectDeepSet(state, `${collectionPath}/fields`, payload.fields)
        Utilities.objectDeepSet(state, `${collectionPath}/actions`, payload.actions)
        Utilities.objectDeepSet(state, `${collectionPath}/count`, payload.count)
    },                  
}



// actions
const actions = {

}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/CollectionsStore.js